import { Component, OnInit } from '@angular/core';
import { LstPostMessageAction } from './../../../../../src/app/core/model/post-message.model';
import { PostMessageService } from './../../../../../src/app/core/services/post-message/post-message.service';
import { EventAction } from '../../../core/model/multi-stage-report-event.model';
import { EventCommunicationService } from '../../../core/services/event-communication/event-communication.service';
import { MultiStageAssignmentReportService } from '../../../core/multi-stage-assignment-report/multi-stage-assignment-report.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
    constructor(
        private readonly multiStageAssignmentReportService: MultiStageAssignmentReportService,
        private readonly postMessageService: PostMessageService,
        private readonly eventCommunicationService: EventCommunicationService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.postMessageService.createParentPostMessageConnection();
        this.multiStageAssignmentReportService.setIsErrorOccurred(true);
        this.multiStageAssignmentReportService.setIsLoading(false);
        this.postMessageService.sendMessageToParent(LstPostMessageAction.LOAD_COMPLETE);
        this.eventCommunicationService.sendEventToParent({action: EventAction.LOAD_COMPLETE});
    }
}
